import { Tag } from "@brg/api";

export const isRequired = (tag: Tag, list?: string[], ignore?: boolean) => {
    const { referenceId, tagId, isEducationTag } = tag;
    if (!ignore && (isEducationTag || !list)) return isEducationTag;
    return list?.includes(referenceId || tagId)
}import { Tag } from "@brg/api";

export const isRequired = (tag: Tag, list?: string[], ignore?: boolean) => {
    const { referenceId, tagId, isEducationTag } = tag;
    if (!ignore && (isEducationTag || !list)) return isEducationTag;
    return list?.includes(referenceId || tagId)
}